import {
  bindHomepageCardClicks,
  EXPERTISE_CARD_CLICK_SELECTOR,
  trackExpertiseCardClick
} from '../analytics/homepage-cards';
import sharedCardCarousel from './shared-card-carousel';

export default function expertiseCardRow(root: HTMLElement): () => void {
  const unbindCarousel = sharedCardCarousel(root, { duration: 35 });
  const unbindCardClicks = bindHomepageCardClicks(root, {
    selector: EXPERTISE_CARD_CLICK_SELECTOR,
    track: trackExpertiseCardClick
  });

  return () => {
    unbindCardClicks();
    unbindCarousel();
  };
}
